export { default as PDPColorwayPicker } from './PDPColorwayPicker'



// WEBPACK FOOTER //
// ./src/components/pdpColorwayPicker/index.js